import { ActionIcon } from "@mantine/core";
import { IconNavigationFilled } from "@tabler/icons-react";

const ResetNorth: React.FC<{ onClick: () => void, rotation: number }> = ({ onClick, rotation }) => {
    return (
        <ActionIcon variant='filled' color='black' size='lg' radius='xl' aria-label='Reset North' style={{ position: 'absolute', top: 'calc(env(safe-area-inset-top, 0px) + 150px)', right: 20 }} onClick={onClick} >
            <IconNavigationFilled color='#B3B3B3' style={{ width: '70%', height: '70%', transform: `rotate(${rotation}deg)` }} stroke={2} />
        </ActionIcon>
    );
}
export default ResetNorth;